<template>
  <div>
    <v-app-bar dark color="primary" app elevation="1">
      <v-container>
        <v-row>
          <v-toolbar-title>Service Legends</v-toolbar-title>

          <v-spacer></v-spacer>

          <Login />
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import Login from "./Login";

import { mapActions } from "vuex";
export default {
  data: () => ({}),
  components: {
    Login
  },
  methods: {
    ...mapActions(["commitRightDrawerState"])
  },
  computed: {}
};
</script>

<style></style>
